import React from 'react';
import Button from 'react-bootstrap/Button';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    sendhoteldata, getallhotels, gethotel,
    updateHotelData, getRooms, getRoomsTypes,
    getserverurl, createroom, createroomtype, createfloor,
    editkamer, deleteRoom, deleteRoomtype, editkamerType, saveCleaningtask, getCleaningtasks, editCleaningTask, deleteCleaningTask,
    saveCleaningtype, getCleaningtypes, getvariabletable
} from "../dbconnector/connector";
import { setErrorMessage } from "../tools/errorhandling";
import { MdEdit, MdDelete } from "react-icons/md";


const TariefDetailsNode = ({ rights, t, disabled, hotel, tarief, events, css }) => {

    const [CleaningTypes, setCleaningTypes] = useState({});
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [cleaningTasks, setCleaningTasks] = useState({});
    const [cleaningtaskarray, setcleaningtasksarray] = useState([]);
    const [fieldDisabled, setfieldDisabled] = useState(true);
    const [rates, setRates] = useState([]);
    const [selectedrate, setSelectedRate] = useState([]);
    const [ratesarray, setRatesarray] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [iconDisabled, setIconDisabled] = useState(false);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)

    useEffect(() => {

        try {
            ResetselectedRow()
            newForm(true)
            refreshRates()
        } catch (error) {
            setErrorMessage("error while retrieving employee list")
        }
        console.log(hotel)

    }, [hotel]);

    const refreshRates = () => {
        ResetselectedRow()
        setRatesarray([]);
        getvariabletable("tarieven").then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setRates(body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    useEffect(() => {

        // reset selected row
        ResetselectedRow()
        setRatesarray([]);
        if (rates.length > 0) {
            rates.forEach((item, index) => {
                setRatesarray(pre => [...pre,
                <div id={item.id} className={index % 2 === 0 ? hotelcss.linkVarient1rates : hotelcss.linkVarient2rates} onClick={() => selectRate(item)} >
                    <p>{item.omschrijving}</p>
                    <div className='crudbuttons'>
                        <MdEdit onClick={iconDisabled ? null : () => handleFloorsEditClick(item.id, item, index)} />
                        <MdDelete onClick={iconDisabled ? null : () => handleFloorDeleteClick(item.id)} />
                    </div>
                </div>
                ])
            })
        }

    }, [rates]);

    const handleFloorsEditClick = (id, item) => { }

    const handleFloorDeleteClick = (id) => { }

    function selectRate(rate) {
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(rate.id).className;
        prevSelectedRecord.current = rate.id
        document.getElementById(rate.id).className = hotelcss.selectedRatesRow
        setSelectedRate(rate);
        calculate(rate.productiviteit);
    }

    function ResetselectedRow() {
        setSelectedRate([])
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = undefined;
        prevSelectedRecord.current = undefined
    }

    useEffect(() => {
        try {
            refreshcleaningtypes(hotel)
            refreshcleaningtasks(hotel)
            if (hotel.length === 0) {
                newForm(true)
            }
        } catch (error) {
            events.setErrorMessage(t("error_retreivingHotels"))
        }


    }, [hotel]);

    useEffect(() => {

        setcleaningtypearray([]);
        if (CleaningTypes.length > 0) {
            const types = CleaningTypes
            types.forEach((item, index) => {
                setcleaningtypearray(pre => [...pre,
                <option value={item.Id}>{item.description}: {item.roomtype_id}</option>
                ])
            })
        }

    }, [CleaningTypes, selectedrate]);

    useEffect(() => {

        setcleaningtasksarray([]);
        if (cleaningTasks.length > 0) {
            const types = cleaningTasks
            types.forEach((item, index) => {
                setcleaningtasksarray(pre => [...pre,
                <option value={item.Id}>{item.taskDescription}</option>
                ])
            })
        }

    }, [cleaningTasks, selectedrate]);

    const refreshcleaningtasks = (hotel) => {
        if (hotel.Hotel_ID) {
            getCleaningtasks(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTasks(body.items)
                    })
                } else {
                    setcleaningtypearray(<option>er zijn geen kuisttaken gedefineerd</option>)
                }
            })
        }
    }


    const refreshcleaningtypes = (hotel) => {
        setcleaningtypearray([]);
        setfieldDisabled(true);
        if (hotel.Hotel_ID) {
            getCleaningtypes(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTypes(body.items)
                    })
                } else {
                    setcleaningtypearray(<option>er zijn geen kuisttypes gedefineerd</option>)
                }

            })
        }
    }

    const newForm = (status) => {

        setfieldDisabled(status);
        ResetselectedRow();
        if (document.getElementById("tarief_Actief") !== undefined) {
            document.getElementById("tarief_Actief").checked = true;
            document.getElementById("tarief_startShift").value = "06:00"
            document.getElementById("tarief_endShift").value = "22:00"
            document.getElementById("tarief_ID").value = ""
            document.getElementById("tarief_omschrijving").value = ""
            document.getElementById("tarief_cleaningtype_Id").value = "-1"
            document.getElementById("tarief_cleaningtask_id").value = "-1"
            document.getElementById("tarief_Tarief").value = ""
             document.getElementById("tarief_productiviteit").value = ""

        }
    }

    const enableForm = (status) => {
        setfieldDisabled(status)
    }

    const cancelForm = () => {
        ////console.log(selectedhotel)
        setfieldDisabled(true)
    }
    const changecheckbox = (e) => {
        setSelectedRate((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })
    }
    const updaterecord = (e) => {
        setSelectedRate((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }
    const calctarief = (e) => {
        console.log(document.getElementById("uurtarief").value)
        setSelectedRate((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
        calculate( e.target.value);

    }
    const calculate = (Productiviteit)=>{
            let uurtarief = hotel.weektarief
            let productiviteit = Productiviteit;//document.getElementById("tarief_productiviteit").value
            if (document.getElementById("uurtarief").value === "1"){
                uurtarief = hotel.zaterdagtarief
            }
            if (document.getElementById("uurtarief").value === "2"){
                uurtarief = hotel.zon_feestdagtarief
            }
            let calctarief = (uurtarief / productiviteit).toFixed(2)
            setSelectedRate((prev) => {
                return {
                    ...prev,
                    tarief:  calctarief
                }
            })
    }


    return (
        <>
            <div id="tarief_details" className={css.regionsgrid}>
                <div id="RegionsList" className="list">
                    {ratesarray}
                </div>&nbsp;
                <div id="hotelsList" className="list noborder noscroll">
                    <label className='formtitleGroupBox'>{t('RateDetails')}</label>
                    <div className="groupbox DarkGreenborder">
                        <div className="tariefsingle">
                            <label className="labelhotel DarkGreencolor">
                                {t('Id')}
                            </label>
                            <input onChange={updaterecord} type="text" id="tarief_ID" name="id" value={selectedrate.id} disabled className='normalinput'></input>
                        </div>
                        <div className="tariefsingle">
                            <label className="labelhotel DarkGreencolor">
                                {t('Active')}
                            </label>
                            <input onChange={changecheckbox} type="checkbox" id="tarief_Actief" className="checkbox" defaultValue={true} name="actief" value={selectedrate.actief} checked={selectedrate.actief} disabled={fieldDisabled}></input>
                        </div>
                        <div className="tariefsingle">
                            <label className="labelhotel DarkGreencolor">
                                {t('Description')}
                            </label>
                            <input onChange={updaterecord} type="text" id="tarief_omschrijving" name="omschrijving" value={selectedrate.omschrijving} disabled={fieldDisabled} className='normalinput'></input>
                        </div>
                        <div className="tariefsingle" id="ContractualHours">
                            <label className="labelhotel DarkGreencolor">
                                {t('kuistype')}
                            </label>
                            <select onChange={updaterecord} id="tarief_cleaningtype_Id" value={selectedrate.cleaningtype_Id} name="cleaningtype_Id" className="selectcleaningtypeoptions" disabled={fieldDisabled}>
                                <option key="-1">--- selecteer een kuistype ---</option>
                                {cleaningtypearray}
                            </select>
                        </div>
                        <div className="tariefsingle" id="ContractualHours">
                            <label className="labelhotel DarkGreencolor">
                                {t('CleaningTask')}
                            </label>
                            <select onChange={updaterecord} value={selectedrate.cleaningtask_id} id="tarief_cleaningtask_id" name="cleaningtask_id" className="selectcleaningtypeoptions" disabled={fieldDisabled}>
                                <option key="-1">{t('selecteertaakindienvantoepassing')}</option>
                                {cleaningtaskarray}
                            </select>
                        </div>
                        <div className="tariefsingle">
                            <label className="labelhotel DarkGreencolor">
                                {t('Uurtarief')}
                            </label>
                            <select id="uurtarief" value={selectedrate.uurtarief} name="uurtarief" className="selectcleaningtypeoptions" onChange={calctarief} disabled={fieldDisabled}>
                                <option id="uurtarief_0" value="0">week</option>
                                <option id="uurtarief_1" value="1">zaterdag</option>
                                <option id="uurtarief_2" value="2">zon- feestdag</option>
                            </select>
                        </div>
                        <div className="tariefdouble" Id="InService">
                            <label className="labelhotel DarkGreencolor">
                                {t('Productiviteit')}
                            </label>
                            <input onChange={calctarief} id="tarief_productiviteit" type='decimal' name="productiviteit" className="normalinput" disabled={fieldDisabled} value={selectedrate.productiviteit}></input>
                            <label className="labelhotel DarkGreencolor">
                                {t('Tarief')}
                            </label>
                            <input onChange={updaterecord} id="tarief_Tarief" type='decimal' name="tarief" className="normalinput" disabled value={selectedrate.tarief}></input>
                        </div>
                        <div className="tariefdouble" Id="OutService">
                            <label className="labelhotel DarkGreencolor">
                                {t('Start')}
                            </label>
                            <input onChange={updaterecord} id="tarief_startShift" type='time' name="start" className="normalinput" defaultValue={"06:00"} disabled={fieldDisabled} value={selectedrate.start}></input>
                            <label className="labelhotel DarkGreencolor">
                                {t('Einde')}
                            </label>
                            <input onChange={updaterecord} id="tarief_endShift" type='time' name="end" className="normalinput" defaultValue={"22:00"} disabled={fieldDisabled} value={selectedrate.end}></input>
                        </div>
                        <div id="saveDiv" className="tarieffourbuttons">
                            <p></p>
                            <Button id="saveButton" type="submit" className='Savebutton' onClick={() => newForm(false)} disabled={hotel.length === 0 ? true : false}>{t('Nieuwtarief')}</Button>
                            <Button id="saveButton" type="submit" className='Savebutton' onClick={() => enableForm(false)} style={fieldDisabled === true ? { display: "block" } : { display: "none" }} disabled={selectedrate.id !== undefined ? false : true}>{t('Edit')}</Button>
                            <Button id="saveButton" type="submit" className='Savebutton' style={fieldDisabled === true ? { display: "none" } : { display: "block" }}>{t('Save')}</Button>
                            <Button id="cancelButton" className='Savebutton' onClick={() => cancelForm(false)} disabled={fieldDisabled} >{t('Cancel')}</Button>
                        </div>
                        <br></br>
                    </div>
                </div>
            </div>
        </>
    );
}


export default TariefDetailsNode;
